import { useCallback, useState } from 'react'

import { Grid, TextField, Typography } from '@mui/material'
import { Button, useCreate, useNotify, useTranslate } from 'react-admin'
import {
  ArtworkApiDTO,
  BeneficiaryApiDTO,
  ProductApiDTO,
} from '../../codegen/generated/Api.schemas'

type ArtworksCreateEmbedProps = {
  beneficiaryId: BeneficiaryApiDTO['id']
  productId: ProductApiDTO['id']
  onCreate: (artwork: ArtworkApiDTO) => void
}

export const ArtworksCreateEmbed = ({
  beneficiaryId,
  productId,
  onCreate,
}: ArtworksCreateEmbedProps) => {
  const translate = useTranslate()
  const notify = useNotify()

  const [createArtwork, { isLoading }] = useCreate('artworks', {}, { returnPromise: true })
  const [name, setName] = useState<string>('')

  const onCreateClick = useCallback(async () => {
    try {
      const artwork = await createArtwork('artworks', {
        data: {
          name,
          beneficiaryId,
          productId,
        },
      })

      onCreate(artwork)
      setName('')
    } catch (e) {
      notify('pages.artworks.dissociateArtworks.createArtwork.error', {
        type: 'error',
      })
    }
  }, [createArtwork, name, beneficiaryId, productId, notify, onCreate])
  return (
    <Grid container item direction="row" spacing={0} paddingLeft={4}>
      <Typography variant="body1" component="b" color="textPrimary" fontWeight="bold">
        {translate('pages.artworks.dissociateArtworks.createArtwork.title')}
      </Typography>
      <TextField
        variant="standard"
        label={translate('_generics.name')}
        value={name}
        onChange={e => setName(e.target.value)}
        fullWidth
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          onCreateClick()
        }}
        label={translate('_generics.create')}
        disabled={isLoading || name.length === 0}
        sx={{
          marginTop: '0.5rem',
        }}
      />
    </Grid>
  )
}
